
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(pageUrl=null) {
        const queryString = new URLSearchParams(pageUrl).toString();
        const url = `${API_URL}/production-model?${queryString}`;
        return axios.get(url, { headers: authHeader() });
    },
    search(searchTerm) {
        const params = new URLSearchParams();
        if (searchTerm) params.append('search', searchTerm);
        params.append('page', 1);
        const url = `${API_URL}/production-model?${params.toString()}`;
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/production-model/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/production-model`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/production-model/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/production-model/${id}`, { headers: authHeader() });
    },
    duplicate(id) {
        return axios.post(`${API_URL}/production-model/${id}/duplicate`, {}, { headers: authHeader() });
    },
   
};